import { createContext, useContext, useState } from 'react';

const ActiveChatDomainContext = createContext({ domain: 'agri', setDomain: () => {} });

export function ActiveChatDomainProvider({ children }) {
  const [domain, setDomain] = useState('agri');
  return <ActiveChatDomainContext.Provider value={{ domain, setDomain }}>
    {children}
  </ActiveChatDomainContext.Provider>;
}

export const useActiveChatDomain = () => useContext(ActiveChatDomainContext);
